import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CaseStudiesSection } from '../components/CaseStudiesSection';
import { VideoTestimonialSection } from '../components/VideoTestimonialSection';
import { ServicesSection } from '../components/ServicesSection';
import { MarketingJourneySection } from '../components/MarketingJourneySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { FAQSection } from '../components/FAQSection';
import { Button } from '../components/Button';
import { PhoneIcon } from 'lucide-react';
export function LandingPage() {
  const scrollToForm = () => {
    const element = document.getElementById('contact-form');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-123">
      {/* Navigation - Sticky */}
      <nav className="fixed top-0 left-0 w-full z-50 border-b border-white/10 bg-[#0A1628]/95 backdrop-blur-md" data-id="element-124">
        <div className="container mx-auto px-6 sm:px-12 lg:px-24 xl:px-32 2xl:px-40" data-id="element-125">
          <div className="flex items-center justify-between h-24" data-id="element-126">
            <div className="flex items-center" data-id="element-127">
              <img src="https://cdn.magicpatterns.com/uploads/d5Rt2q5xxrBaS9DBEGb4aS/Dealers-Choice-Solutions-Logo-(Dark-Blue-BG).png" alt="DealersChoice Solutions" className="h-16 lg:h-20 w-auto" data-id="element-128" />
            </div>
            <div className="flex items-center gap-5" data-id="element-129">
              <a href="tel:+15188389060" className="flex items-center gap-2 text-white hover:text-[#D4AF37] transition-colors duration-200" data-id="element-130">
                <PhoneIcon className="w-4 h-4" data-id="element-131" />
                <span className="text-sm font-semibold underline" data-id="element-132">
                  (518) 838-9060
                </span>
              </a>
              <Button variant="primary" className="px-6 py-2.5 text-sm font-semibold" onClick={scrollToForm} data-id="element-133">
                Book A Free Strategy Call
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <main className="flex-grow" data-id="element-134">
        <HeroSection data-id="element-135" />
        <VideoTestimonialSection data-id="element-136" />
        <ServicesSection data-id="element-137" />
        <MarketingJourneySection data-id="element-138" />
        <CaseStudiesSection data-id="element-139" />
        <FinalCTASection data-id="element-140" />
        <FAQSection data-id="element-141" />
      </main>
    </div>;
}